<template>
  <v-card>
    <v-card-title>
      <v-flex xs2>
        <div class="title">Rates</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="key" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
      <td v-for="column in selectedColumns" :key="column">
        {{props.item[column]}}
      </td>
      <td class="text-xs-right">
        <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
      </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doCreate">New Rate<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Tariff Rate?
      <div class="title">{{deleteTarfRate}}</div>
    </confirm>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { expandURI } from '@/utils/ajax'
import { mapActions } from 'vuex'
import FieldMixin from '@/mixins/field'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      // Default Layout
      columns: [
        { text: 'Sequence', value: 'seqNo' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' },
        { text: 'Factor 1', value: 'fact1' },
        { text: 'Factor 2', value: 'fact2' },
        { text: 'Factor 3', value: 'fact3' },
        { text: 'Factor 4', value: 'fact4' },
        { text: 'Factor 5', value: 'fact5' },
        { text: 'Factor 6', value: 'fact6' },
        { text: 'Tariff Rate', value: 'tarfRate' },
        { text: 'Min Annual Premium', value: 'minAp' },
        { text: 'Max Annual Premium', value: 'maxAp' },
        { text: 'Base Annual Premium', value: 'baseAp' },
        { text: 'Base Sum Insured', value: 'baseSi' },
        { text: '% Increase Base Annual Premium', value: 'pctIncBaseAp' },
        { text: 'Increase Sum Insured', value: 'incSi' },
        { text: 'increase Annual Premium Base', value: 'incApbase' }
      ],
      selectedColumns: ['tarfRate', 'fact1', 'fact2', 'fact3', 'fact4', 'fact5', 'fact6'],
      pagination: {
        sortBy: 'tarfRate'
      },
      loading: false,
      deleteTarfRate: '',
      promptRemove: false
    }
  },
  watch: {
    'fetchRate': function(value) {
      if (value !== false) {
        if (this.ids.seqNo !== 'new') {
          this.fetchData(this.ids.seqNo)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'tariffFactorInit'
    ]),
    async fetchData(value) {
      const expand = {
        busCls: this.ids.busCls,
        tarf: this.ids.tarf,
        benefit: this.ids.benefit,
        effDate: this.ids.factEffDate,
        seqNo: this.ids.seqNo
      }
      await this.tariffFactorInit(expand)
      this.loading = true
      const apiURI = this.$store.state.parameters.tariff.factor.menu.tarfRates
      if (apiURI) {
        const expand = {
          busCls: this.ids.busCls,
          tarf: this.ids.tarf,
          benefit: this.ids.benefit,
          seqNo: this.ids.seqNo
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((tarfRates) => {
              const convertList = {
                benefit: tarfRates.benefit,
                seqNo: tarfRates.seqNo,
                effDate: this.formatDate(tarfRates.effDate),
                expDate: this.formatDate(tarfRates.expDate),
                fact1: tarfRates.fact1,
                fact2: tarfRates.fact2,
                fact3: tarfRates.fact3,
                fact4: tarfRates.fact4,
                fact5: tarfRates.fact5,
                fact6: tarfRates.fact6,
                tarfRate: formatDisplayNumber(tarfRates.tarfRate),
                minAp: formatDisplayNumber(tarfRates.minAp),
                maxAp: formatDisplayNumber(tarfRates.maxAp),
                baseAp: formatDisplayNumber(tarfRates.baseAp),
                baseSi: formatDisplayNumber(tarfRates.baseSi),
                pctIncBaseAp: formatDisplayNumber(tarfRates.pctIncBaseAp),
                incSi: formatDisplayNumber(tarfRates.incSi),
                incApbase: formatDisplayNumber(tarfRates.incApbase)
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (error) {
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API Url - Rate List')
        this.loading = false
      }
    },
    doHeader() {
      this.columns = [
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' },
        { text: 'Tariff Rate', value: 'tarfRate' },
        { text: 'Min Annual Premium', value: 'minAp' },
        { text: 'Max Annual Premium', value: 'maxAp' },
        { text: 'Base Annual Premium', value: 'baseAp' },
        { text: 'Base Sum Insured', value: 'baseSi' },
        { text: '% Increase Base Annual Premium', value: 'pctIncBaseAp' },
        { text: 'Increase Sum Insured', value: 'incSi' },
        { text: 'increase Annual Premium Base', value: 'incApbase' }
      ]
      this.selectedColumns = ['tarfRate']
      if (this.factForm.factorByFact1 !== null) {
        this.columns.push({ text: this.factForm.factorByFact1, value: 'fact1' })
        this.selectedColumns.push('fact1')
      }
      if (this.factForm.factorByFact2 !== null) {
        this.columns.push({ text: this.factForm.factorByFact2, value: 'fact2' })
        this.selectedColumns.push('fact2')
      }
      if (this.factForm.factorByFact3 !== null) {
        this.columns.push({ text: this.factForm.factorByFact3, value: 'fact3' })
        this.selectedColumns.push('fact3')
      }
      if (this.factForm.factorByFact4 !== null) {
        this.columns.push({ text: this.factForm.factorByFact4, value: 'fact4' })
        this.selectedColumns.push('fact4')
      }
      if (this.factForm.factorByFact5 !== null) {
        this.columns.push({ text: this.factForm.factorByFact5, value: 'fact5' })
        this.selectedColumns.push('fact5')
      }
      if (this.factForm.factorByFact6 !== null) {
        this.columns.push({ text: this.factForm.factorByFact6, value: 'fact6' })
        this.selectedColumns.push('fact6')
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doCreate() {
      this.$emit('doCreate', this.ids)
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTarfRate = data
        this.deleteTarfRate = data.seqNo + ' - ' + data.effDate
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.tariff.factor.menu.tarfRateDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.ids.busCls,
          tarf: this.ids.tarf,
          benefit: this.ids.benefit,
          effDate: this.removeFormatDate(this.selectedTarfRate.effDate),
          seqNo: this.ids.seqNo,
          expDate: this.removeFormatDate(this.selectedTarfRate.expDate),
          tarfRate: removeFormatNumber(this.selectedTarfRate.tarfRate),
          minAp: removeFormatNumber(this.selectedTarfRate.minAp),
          maxAp: removeFormatNumber(this.selectedTarfRate.maxAp),
          baseAp: removeFormatNumber(this.selectedTarfRate.baseAp),
          baseSi: removeFormatNumber(this.selectedTarfRate.baseSi),
          pctIncBaseAp: removeFormatNumber(this.selectedTarfRate.pctIncBaseAp),
          incSi: removeFormatNumber(this.selectedTarfRate.incSi),
          incApbase: removeFormatNumber(this.selectedTarfRate.incApbase),
          fact1: this.selectedTarfRate.fact1,
          fact2: this.selectedTarfRate.fact2,
          fact3: this.selectedTarfRate.fact3,
          fact4: removeFormatNumber(this.selectedTarfRate.fact4),
          fact5: removeFormatNumber(this.selectedTarfRate.fact5),
          fact6: removeFormatNumber(this.selectedTarfRate.fact6)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.seqNo)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Tariff Rate')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  props: {
    ids: Object,
    fetchRate: Boolean
  },
  mixins: [
    listMixin,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
